import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { commonString } from "../../../../../AdminApi/commFunc";
import { useApi } from "../../../../../hooks/useApi";
import RadioBtn from "../../../../Button/RadioBtn";
import Flex from "../../../../DefaultStyles/Flex";
import Loader from "../../../../DefaultStyles/Loader";
import { OptionType } from "../../../../Filters/DropDown";
import { Input } from "../../../../Input/Input";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import FaqCategoryDropdown from "./FaqCategoryDropdown";

interface FaqCategoryModalProps extends DefaultModalCommonProps {}

export default function FaqCategoryModal({
  closeEvent,
}: FaqCategoryModalProps) {
  const { pathname } = useLocation();

  const [check, setCheck] = useState({
    add: true,
    update: false,
  });

  const [categoryDropdown, setCategoryDropdown] = useState<OptionType>({
    value: "",
    label: "변경할 카테고리 선택",
  });
  const [addCategory, setAddCategory] = useState(""); // 추가할 카테고리
  const [updateCategory, setUpdateCategory] = useState(""); // 변경되는 카테고리

  const [selectedCategoryId, setSelectedCategoryId] = useState(0); // 선택된(변경할) 카테고리

  const [addAction, setAddAction] = useState(false); // 추가 실행
  const [askUpdateModal, setAskUpdateModal] = useState(false); // 변경 실행 ask 모달
  const [updateAction, setUpdateAction] = useState(false); // 변경 실행
  const [duplicated, setDuplicated] = useState(false); // 중복된 카테고리

  // 카테고리 추가
  const { response, loading, error } = useApi({
    method: "post",
    url: addAction ? `category` : undefined,
    data: {
      name: addCategory,
      type: commonString(pathname).type ?? 0,
    },
  });

  // 카테고리 변경
  const {
    response: updateResponse,
    loading: updateLoading,
    error: updateError,
  } = useApi({
    method: "post",
    url:
      updateAction && selectedCategoryId > 0
        ? `category/${selectedCategoryId}`
        : undefined,
    data: {
      name: updateCategory,
      type: commonString(pathname).type ?? 0,
    },
  });

  console.log(selectedCategoryId);

  useEffect(() => {
    if (response?.status === 200 || updateResponse?.status === 200) {
      setAddAction(false);
      setUpdateAction(false);
      toast.success(
        check?.add ? "카테고리가 추가되었습니다." : "카테고리가 변경되었습니다."
      );
      closeEvent();
    }
  }, [response, updateResponse]);

  useEffect(() => {
    if (error || updateError) {
      setAddAction(false);
      setUpdateAction(false);
      toast.error(
        error?.data ??
          updateError?.data ??
          (check?.add
            ? "카테고리 추가에 실패하였습니다."
            : "카테고리 변경에 실패하였습니다.")
      );
    }
  }, [error, updateError]);

  useEffect(() => {
    if (categoryDropdown?.value !== "") {
      setSelectedCategoryId(Number(categoryDropdown?.value ?? 0));
    }
  }, [categoryDropdown]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="카테고리 추가 및 변경"
        confirmEvent={() => {
          if (check.add) {
            setAddAction(true);
          } else {
            setAskUpdateModal(true);
          }
        }}
        closeEvent={() => closeEvent()}
        isMediumModal={true}
        confirmDisabled={
          check.add
            ? addCategory === ""
            : categoryDropdown?.value === "" || updateCategory === ""
        }
      >
        <CategoryTypeContainer>
          <ModalLabel>구분</ModalLabel>

          <Flex gapSize={55} style={{ marginTop: 12 }}>
            <RadioBtn
              label="추가"
              check={check.add}
              noTooltip={true}
              clickEvent={() => {
                setCheck({
                  add: !check.add,
                  update: false,
                });
                setAddAction(false);
              }}
            />

            <RadioBtn
              label="변경"
              check={check.update}
              noTooltip={true}
              clickEvent={() => {
                setCheck({
                  add: false,
                  update: !check.update,
                });
                setUpdateAction(false);
              }}
            />
          </Flex>
        </CategoryTypeContainer>

        <CategoryContent>
          {check?.update && (
            <Flex gapSize={40} style={{ marginBottom: 12 }}>
              <ModalLabel>카테고리 선택</ModalLabel>

              <FaqCategoryDropdown
                dropdownValue={categoryDropdown}
                setDropDownValue={setCategoryDropdown}
                boxWidth={298}
              />
            </Flex>
          )}

          <Flex gapSize={40}>
            <ModalLabel>카테고리 입력</ModalLabel>

            <Input
              placeholder="직접 입력"
              style={{ width: "calc(100% - 116px)" }}
              value={check.add ? addCategory : updateCategory}
              onChange={(e) => {
                if (check.add) {
                  setAddCategory(e.target.value);
                } else {
                  setUpdateCategory(e.target.value);
                }
              }}
            />
          </Flex>
        </CategoryContent>
      </DefaultModalLayout>

      {(loading || updateLoading) && <Loader />}

      {askUpdateModal && (
        <AlertModal
          title={`기존 카테고리가 변경된 카테고리로 일괄 적용됩니다.
      계속 하시겠습니까?`}
          cancelEvent={() => setAskUpdateModal(false)}
          confirmEvent={() => {
            setUpdateAction(true);
            setAskUpdateModal(false);
          }}
        />
      )}

      {duplicated && (
        <AlertModal
          title={`이미 존재하는 카테고리입니다.
    다시 입력해 주세요.`}
          btnColor="mint"
          confirmEvent={() => setDuplicated(false)}
          customCancelBtn={<></>}
        />
      )}
    </>
  );
}

const CategoryTypeContainer = styled.div``;

const CategoryContent = styled.div`
  margin-top: 28px;
`;
